import {
  ADD_MESSAGES,
  FETCHING_MESSAGES,
  FETCHED_MESSAGES,
  PREPEND_MESSAGE,
  UPDATE_MESSAGE,
} from '../constants';

interface MessagesState {
  /** Keyed by project_id (string). Each value is the sorted message list for that project. */
  list: Record<string, any[]>;
  fetching: boolean;
  /** Tracks last-fetched timestamp per project_id to avoid redundant API calls. */
  fetched: Record<string, number>;
}

const initialState: MessagesState = {
  list: {},
  fetching: false,
  fetched: {},
};

export default function messagesReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): MessagesState {
  switch (type) {
    case ADD_MESSAGES:
      return {
        ...state,
        list: { ...state.list, [String(payload.project_id)]: payload.list },
        fetching: false,
      };
    case FETCHING_MESSAGES:
      return { ...state, fetching: payload };
    case FETCHED_MESSAGES:
      return { ...state, fetched: { ...state.fetched, [String(payload.project_id)]: Date.now() } };
    case PREPEND_MESSAGE: {
      const key = String(payload.project_id);
      const existing = state.list[key] ?? [];
      const alreadyExists = existing.some((m: any) => m.id === payload.message.id);
      return {
        ...state,
        list: {
          ...state.list,
          [key]: alreadyExists
            ? existing.map((m: any) => m.id === payload.message.id ? { ...m, ...payload.message } : m)
            : [payload.message, ...existing],
        },
      };
    }
    case UPDATE_MESSAGE: {
      const key = String(payload.project_id);
      const existing = state.list[key] ?? [];
      return {
        ...state,
        list: {
          ...state.list,
          [key]: existing.map(m =>
            m.id === payload.message.id ? { ...m, ...payload.message } : m
          ),
        },
      };
    }
    default:
      return state;
  }
}
